<template>
  <component v-bind:is="SystemUpdate"/>
  <component v-bind:is="SystemLockScreen"/>
  <component v-bind:is="SystemAuth" v-if="!isAuth && !isGuest"/>
  <component v-bind:is="SystemIndex" v-if="isAuth || isGuest">
    <template #main>
      <component v-bind:is="SystemWinMain"/>
    </template>
    <template #support>
      <component v-bind:is="SystemWinSupport"/>
    </template>
  </component>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, onMounted, onUnmounted } from 'vue'

import { SysAuthProviderModule } from '@/system-modules/auth/SysAuthProvider'
import { SysLockScreenProviderModule } from '@/system-modules/lock-screen/LockScreenProvider'
import { SysWinManagerProviderModule } from '@/system-modules/win-manager/WinManagerProvider'
import { SysUpdateProviderModule } from '@/system-modules/update/SysUpdateProvider'
import { sys } from '@/system/SystemProvider'
import { readShareLinkUuid } from '@/helpers/shareLink'

const SystemIndex = defineAsyncComponent(() => import('@/system' + sys().getViewPath()))
const SystemAuth = defineAsyncComponent(() => import('@/system-modules' + SysAuthProviderModule().getViewPath()))
const SystemUpdate = defineAsyncComponent(() => import('@/system-modules' + SysUpdateProviderModule().getViewPath()))
const SystemLockScreen = defineAsyncComponent(() => import('@/system-modules' + SysLockScreenProviderModule().getViewPath()))
const SystemWinMain = defineAsyncComponent(() => import('@/system-modules' + SysWinManagerProviderModule().getMainWinPath()))
const SystemWinSupport = defineAsyncComponent(() => import('@/system-modules' + SysWinManagerProviderModule().getWidgetWinPath()))

const isAuth = computed(() => sys().auth.isAuth())
const isGuest = computed(() => sys().share.isGuest())

// использование системы — указатель мыши в области страницы: пока он там, идёт heartbeat
const onPointerEnter = () => sys().auth.startHeartbeat()
const onPointerLeave = () => sys().auth.stopHeartbeat()

onMounted(() => {
  document.documentElement.addEventListener('mouseenter', onPointerEnter)
  document.documentElement.addEventListener('mouseleave', onPointerLeave)
  // адрес ссылки share открывает страницу гостю без входа; иначе восстанавливается сеанс
  const linkUuid = readShareLinkUuid(window.location.hash)
  if (linkUuid) {
    sys().share.openGuestLink(linkUuid)
  } else {
    sys().auth.restoreSession()
  }
})

onUnmounted(() => {
  document.documentElement.removeEventListener('mouseenter', onPointerEnter)
  document.documentElement.removeEventListener('mouseleave', onPointerLeave)
})
</script>

<style lang="scss">

@import "@/assets/themes/default/styles.scss";

#app{
  display: flex;
  flex-direction: column;
  height: 100vh;
  font-family: Roboto, Verdana, Arial, sans-serif;
  font-weight: 400;
}
</style>
